// src/shared/components/Layout/SideBar.tsx
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/shared/auth';

type MenuItem = { path: string; label: string; ability?: string };

const BASE_LINK   = 'block px-4 py-2 rounded-md hover:bg-neutral-950 transition-colors';
const ACTIVE_LINK = 'bg-neutral-800 text-neutral-100 font-bold';
const ROOT        = 'relative h-screen w-52 bg-neon_purple-1000 text-neutral-300 flex flex-col';
const LOGOUT_BTN  = 'absolute bottom-4 left-4 right-4 bg-neon_red-800 hover:bg-neon_red-500 text-neutral-100 px-4 py-2 rounded text-left';

export default function Sidebar() {
  const navigate = useNavigate();
  const { nav = [], loading, logout, perms } = useAuth() as any;  // include perms set
  const [loggingOut, setLoggingOut] = useState(false);

  return (
    <aside className={ROOT}>
      <div className="p-4 text-lg font-semibold">PACMaster</div>

      <nav className="flex-1 space-y-1 overflow-y-auto">
        {loading && (
          <div className="px-4 py-2 text-neutral-500">Loading menu…</div>
        )}
        {!loading && nav.length === 0 && (
          <div className="px-4 py-2 text-neutral-500">No sections available.</div>
        )}
        {nav
          .filter(({ path, ability }: MenuItem) => {
            // Ability-based guard: if an ability is defined and user lacks it, hide the item
            if (ability && !perms.has(ability)) return false;
            // Additional special-case: the base TT-Lock dashboard root requires superadmin ability
            if (path === '/ttlock' && !perms.has('ttlock.room.superadmin')) return false;
            return true;
          })
          .map(({ path, label }: MenuItem) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `${BASE_LINK} ${isActive ? ACTIVE_LINK : ''}`}
            end
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <button
        onClick={async () => {
          setLoggingOut(true);
          try { await logout(); } finally {
            setLoggingOut(false);
            navigate('/login', { replace: true });
          }
        }}
        disabled={loggingOut}
        className={`${LOGOUT_BTN} ${loggingOut ? 'opacity-60 cursor-not-allowed' : ''}`}
      >
        {loggingOut ? 'Logging out…' : 'Log out'}
      </button>
    </aside>
  );
}
